// Password validation and strength checking utilities

export function togglePassword(fieldId) {
  const field = document.getElementById(fieldId);
  const eyeIcon = document.getElementById(fieldId + '-eye');

  if (field.type === 'password') {
    field.type = 'text';
    eyeIcon.classList.remove('fa-eye');
    eyeIcon.classList.add('fa-eye-slash');
  } else {
    field.type = 'password';
    eyeIcon.classList.remove('fa-eye-slash');
    eyeIcon.classList.add('fa-eye');
  }
}

export function checkPasswordStrength() {
  const password = document.getElementById('password').value;
  const requirements = {
    length: password.length >= 12,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(password)
  };

  // Update requirement indicators
  Object.keys(requirements).forEach(req => {
    const element = document.querySelector(`[data-requirement="${req}"]`);
    if (!element) return;

    const icon = element.querySelector('i');

    if (requirements[req]) {
      icon.classList.remove('fa-times', 'text-danger');
      icon.classList.add('fa-check', 'text-success');
      element.classList.add('text-success');
      element.classList.remove('text-muted');
    } else {
      icon.classList.remove('fa-check', 'text-success');
      icon.classList.add('fa-times', 'text-danger');
      element.classList.remove('text-success');
      element.classList.add('text-muted');
    }
  });

  // Calculate strength
  const score = Object.values(requirements).filter(Boolean).length;
  const strengthBar = document.getElementById('strength-bar');
  const strengthText = document.getElementById('strength-text');

  if (!strengthBar || !strengthText) return;

  if (password.length === 0) {
    strengthBar.style.width = '0%';
    strengthBar.className = 'strength-bar';
    strengthText.textContent = 'Enter a password to see strength';
    strengthText.className = 'strength-text text-muted';
    return;
  }

  const percentage = (score / 5) * 100;
  strengthBar.style.width = percentage + '%';

  if (score < 2) {
    strengthBar.className = 'strength-bar weak';
    strengthText.textContent = 'Weak password';
    strengthText.className = 'strength-text text-danger';
  } else if (score < 4) {
    strengthBar.className = 'strength-bar medium';
    strengthText.textContent = 'Medium strength';
    strengthText.className = 'strength-text text-warning';
  } else if (score < 5) {
    strengthBar.className = 'strength-bar strong';
    strengthText.textContent = 'Strong password';
    strengthText.className = 'strength-text text-info';
  } else {
    strengthBar.className = 'strength-bar excellent';
    strengthText.textContent = 'Excellent password!';
    strengthText.className = 'strength-text text-success';
  }

  // Check match if confirm password has value
  const confirmPassword = document.getElementById('confirm_password');
  if (confirmPassword && confirmPassword.value) {
    checkPasswordMatch();
  }
}

export function checkPasswordMatch() {
  const password = document.getElementById('password').value;
  const confirmPassword = document.getElementById('confirm_password').value;
  const matchText = document.getElementById('match-text');

  if (!matchText) return;

  if (confirmPassword.length === 0) {
    matchText.textContent = '';
    return;
  }

  if (password === confirmPassword) {
    matchText.innerHTML = '<i class="fas fa-check text-success me-2"></i>Passwords match';
    matchText.className = 'match-text text-success';
  } else {
    matchText.innerHTML = '<i class="fas fa-times text-danger me-2"></i>Passwords do not match';
    matchText.className = 'match-text text-danger';
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Make functions available globally for onclick handlers
  window.togglePassword = togglePassword;
  window.checkPasswordStrength = checkPasswordStrength;
  window.checkPasswordMatch = checkPasswordMatch;
});
